module.exports = __webpack_public_path__ + "img/skillset-gem-3.907295d7.png";